// app/javascript/controllers/dae20/component_template_preview_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    previewUrl: String,
    frameId: String
  }
  connect() {
    console.log('ComponentTemplatePreviewController connected')
    // no-op
  }

  change(event) {
    const selectedId = event.target.value
    const frameId = this.frameIdValue
    const frame = document.getElementById(frameId)
    if (!frame) return

    if (!selectedId) {
      frame.innerHTML = '<div class="rounded-md border border-dashed border-gray-300 p-4 text-sm text-gray-400">Выберите шаблон данных, чтобы увидеть предпросмотр</div>'
      frame.removeAttribute('src')
      return
    }

    const templateId = this.element.dataset.templateId
    const pageId = this.element.dataset.pageId

    const url = new URL(this.previewUrlValue || '/', window.location.origin)
    // Исправленная строка - используем правильную переменную pageId
    url.pathname = `/dae20/workspace/${templateId}/pages/${pageId}/components/template_preview`

    url.searchParams.set('template_item_id', selectedId)
    url.searchParams.set('frame_id', frameId)

    frame.setAttribute('src', url.toString())
  }
}
